import { Routes } from '@angular/router';
import { LandingPageComponent } from './pages/landing-page/landing-page.component';
import { LoginComponent } from './pages/login/login.component';
import { RegisterFeedbackComponent } from './pages/register-feedback/register-feedback.component';
import { RegisterComponent } from './pages/register/register.component';
import { ProductsComponent } from './pages/products/products.component';
import { LoginGuardService } from './services/login-guard.service';
import { SerialCheckComponent } from './pages/serial-check/serial-check.component';

export const routes: Routes = [
  {
    path: '',
    component: LandingPageComponent
  },
  {
    path: 'login',
    component: LoginComponent
  },
  {
    path: 'register',
    component: RegisterComponent
  },
  {
    path: 'feedback',
    component: RegisterFeedbackComponent
  },
  {
    path: 'products',
    component: ProductsComponent,
    canActivate: [LoginGuardService]
  },
  {
    path: 'serial-check',
    component: SerialCheckComponent
  },
  {
    path: '**',
    redirectTo: ''
  }
];
